import { c as _c } from "react/compiler-runtime";
import { readFragment } from "@opensea/graphql";
import { Table } from "@opensea/ui-kit";
import { TransferFlowReviewItem } from "./TransferFlowReviewItem";
import { TransferFlowReviewItemsFragment } from "./TransferFlowReviewItems.fragment";
export const TransferFlowReviewItems = t0 => {
  const $ = _c(5);
  const {
    items: itemKeys,
    formValues
  } = t0;
  let t1;
  if ($[0] !== formValues.items || $[1] !== itemKeys) {
    const items = itemKeys.map(_temp);
    t1 = formValues.items.flatMap(formItem => {
      const matchedItem = items.find(item => item.id === formItem.id);
      return matchedItem ? [matchedItem] : [];
    });
    $[0] = formValues.items;
    $[1] = itemKeys;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const tableItems = t1;
  let t2;
  if ($[3] !== tableItems) {
    t2 = <Table itemKey={_temp2} items={tableItems} renderRow={TransferFlowReviewItem} size="lg" />;
    $[3] = tableItems;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
function _temp(itemKey) {
  return readFragment(TransferFlowReviewItemsFragment, itemKey);
}
function _temp2(_, index) {
  return index;
}